import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="selectbox-polymorphic"
export default class extends Controller {
	static targets = ["type", "destroy"]
	connect() {}

	// Setzt den type des Polymorphic-Elements in das passende Feld und entscheidet bei Bedarf, ob das Element gelöscht werden muss.
	update({ currentTarget }) {
		const polymorphicType = currentTarget.selectedOptions[0].dataset.type

		this.typeTarget.value = polymorphicType === "nil" ? "" : polymorphicType

		if (this.hasDestroyTarget) {
			this.destroyTarget.value = polymorphicType === "nil" ? 1 : 0
		}
	}
}
